/**
 * Languages API Service
 * Handles fetching active languages from the system
 */

import { api } from '../utils/api';
import type { Language } from '../types/language';
import type { PaginatedResponse } from '../types/common';

/**
 * Languages Service
 * Fetches active languages for forms and UI
 */
export const languagesService = {
  /**
   * Get all active languages
   * Returns languages in specific order: en, ar, ur, ae, tr, ru, fr, de, id, fa, es
   * Note: API returns paginated response, we extract the results array
   */
  getAll: async (): Promise<Language[]> => {
    const response = await api.get<PaginatedResponse<Language>>('/languages/?page_size=100&is_active=true');
    return response.results || [];
  },
};
